export default "__VITE_ASSET__JHmnjQiD__"